import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const HeroSection = ({ onBookConsultation }) => {
  return (
    <div className="relative h-[60vh] min-h-[500px] overflow-hidden mb-12">
      {/* Background Image */}
      <img
        src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
        alt="Sherpa guides in the Himalayas"
        className="w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />

      {/* Content */}
      <div className="absolute inset-0 flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-headline text-white mb-6 leading-tight" style={{ fontWeight: 300 }}>
              Guided by Generations of
              <span className="block text-sunrise-gold">Mountain Wisdom</span>
            </h1>

            <p className="text-xl text-white/90 font-body leading-relaxed mb-8 max-w-xl">
              Each of our certified Sherpa guides brings decades of mountain
              expertise, deep cultural knowledge, and an unwavering commitment
              to your safety and transformation.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-12 pt-8 border-t border-white/20">
              <div>
                <div className="text-3xl font-bold text-white mb-1">5+</div>
                <div className="text-white/80 text-sm">Expert Guides</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">100+</div>
                <div className="text-white/80 text-sm">
                  Successful Expeditions
                </div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">4.9</div>
                <div className="text-white/80 text-sm">Average Rating</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
